import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getInitials, formatHandicap, formatAvailability } from '../utils/format';
import Icon from '../components/Icon';
import './Profile.css';

function Profile() {
  const { user, signOut } = useAuth();

  const handicapDisplay = formatHandicap(user?.handicap);

  return (
    <div className="profile-page container">

      {/* Hero Banner */}
      <div className="profile-hero">
        <div className="profile-hero-content">
          <div className="avatar avatar-xl">
            {user?.photo_url
              ? <img src={user.photo_url} alt={user.name} />
              : getInitials(user?.name)
            }
          </div>
          <div className="profile-hero-info">
            <p className="profile-hero-name">{user?.name}</p>
            <p className="profile-hero-email">{user?.email}</p>
            {user?.home_course && (
              <p className="profile-hero-course"><Icon name="flag" size={15} /> {user.home_course}</p>
            )}
            <p className="profile-hero-location">
              <Icon name="pin" size={15} /> {user?.city ? `${user.city}${user.state ? `, ${user.state}` : ''}` : 'No location set'}
            </p>
          </div>
        </div>
      </div>

      {/* Handicap Index + GHIN */}
      <div className="handicap-display">
        <div className="handicap-index-block">
          <span className="handicap-index-label">Handicap Index</span>
          <span className={`handicap-index-value ${!handicapDisplay ? 'not-set' : ''}`}>
            {handicapDisplay || 'N/A'}
          </span>
          {user?.ghin_number && (
            <span className={`ghin-badge ${user.ghin_verified ? 'ghin-verified' : 'ghin-pending'}`}>
              {user.ghin_verified ? 'GHIN Verified' : `GHIN #${user.ghin_number}`}
            </span>
          )}
        </div>
        <div className="handicap-meta">
          <div className="handicap-meta-item">
            <span className="handicap-meta-value" style={{ textTransform: 'capitalize' }}>
              {user?.playing_style || '—'}
            </span>
            <span className="handicap-meta-label">Playing Style</span>
          </div>
          <div className="handicap-meta-item">
            <span className="handicap-meta-value" style={{ textTransform: 'capitalize' }}>
              {user?.preferred_tees ? `${user.preferred_tees} tees` : '—'}
            </span>
            <span className="handicap-meta-label">Preferred Tees</span>
          </div>
          <div className="handicap-meta-item">
            <span className="handicap-meta-value" style={{ textTransform: 'capitalize' }}>
              {user?.pace_preference || '—'}
            </span>
            <span className="handicap-meta-label">Pace</span>
          </div>
        </div>
      </div>

      {/* Details */}
      <div className="profile-details-card">
        {user?.bio && (
          <div className="profile-section">
            <p className="profile-section-label">About</p>
            <p className="profile-section-value">{user.bio}</p>
          </div>
        )}

        <div className="profile-section">
          <p className="profile-section-label">Availability</p>
          <p className="profile-section-value">{formatAvailability(user?.availability)}</p>
        </div>

        <div className="profile-section">
          <p className="profile-section-label">Location</p>
          {user?.latitude != null && user?.longitude != null ? (
            <p className="profile-section-value location-set">
              <Icon name="check" size={16} /> Location set — you show up in nearby searches
            </p>
          ) : (
            <p className={`profile-section-value location-not-set`}>
              No location set — add it to appear in nearby searches
            </p>
          )}
        </div>
      </div>

      {/* Actions */}
      <div className="profile-actions">
        <Link to="/qr" className="btn btn-primary btn-block btn-lg">
          <Icon name="qr" size={18} /> My QR Code
        </Link>
        <Link to="/profile/edit" className="btn btn-secondary btn-block">
          Edit Profile
        </Link>
        <button onClick={signOut} className="btn btn-secondary btn-block">
          Sign Out
        </button>
      </div>

    </div>
  );
}

export default Profile;
